import {
  ErrorBoundary,
  POSNotificationContainer,
  POSQueryClientProvider,
} from '@publicisgroupe/p-os-components';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from './contexts/AuthProvider';
import { useRootApp } from './hooks/useRootApp';
import ModuleRouter from 'components/ModuleRouter';
import ModuleRouterProvider from 'components/ModuleRouterProvider';

export const RootApp = () => {
  const { msalInstance } = useRootApp();

  return (
    <MsalProvider instance={msalInstance}>
      <ErrorBoundary>
        <AuthProvider>
          <POSQueryClientProvider options={{ queries: { staleTime: 5 * 60 * 1000 } }}>
            <POSNotificationContainer position={'bottom-right'} limit={3} />
            <ModuleRouterProvider>
              <ModuleRouter />
            </ModuleRouterProvider>
          </POSQueryClientProvider>
        </AuthProvider>
      </ErrorBoundary>
    </MsalProvider>
  );
};
